import React from "react";
import "./CovidInfo.css";
import covidVirus from "../assets/images/covid-virus.jpg"; // adjust path as needed

const CovidInfo: React.FC = () => {
  return (
    <div className="covid-container">
      <h1>COVID-19 Outbreak Information</h1>

      <p>
        COVID-19 is an infectious disease caused by the SARS-CoV-2 virus. It
        primarily spreads through respiratory droplets when an infected person
        coughs, sneezes, or talks. Symptoms can range from mild to severe, and
        some cases can be fatal, especially in older adults or people with
        underlying health conditions.
      </p>

      <h2>Precautions to Stay Safe</h2>
      <ul>
        <li>Wear masks in crowded or enclosed spaces.</li>
        <li>Wash hands frequently with soap for at least 20 seconds.</li>
        <li>Maintain social distancing of at least 1 meter (3 feet).</li>
        <li>Avoid touching your face, especially eyes, nose, and mouth.</li>
        <li>Get vaccinated and follow local health guidelines.</li>
      </ul>

      <h2>Travel Guidelines</h2>
      <p>
        Check local travel advisories before planning your trips. Some
        countries may require quarantine or negative COVID-19 tests upon
        arrival. Always follow airline and destination rules to ensure a safe
        journey.
      </p>

      <div className="covid-banner">
      <img src={covidVirus} alt="COVID-19 Virus" />
    </div>

    </div>
  );
};

export default CovidInfo;
